import { useDispatch, useSelector } from "react-redux";
import {
  Breakpoints,
  getHomePageABCTestForDomainEnabled,
  useBreakpointPrecise,
  useMount,
} from "src/features/homePageABCTest/imports";
import { deviceInfoSelectors } from "src/features/homePageABCTest/imports/selectors";
import {
  RootState,
  getHomePageABCTestChances,
  getHomePageABCTestHash,
  getIsHomePageABCTestEnabled,
  setABCTestValues,
  setBgVideo,
} from "src/features/homePageABCTest/imports/state";
import { generateHomePageABCTestVariant } from "src/features/homePageABCTest/utils/generateHomePageABCTestVariant";
import { getHomePageABCTestObject } from "src/features/homePageABCTest/utils/getHomePageABCTestVariant";

const selector = (state: RootState) => ({
  locale: deviceInfoSelectors.getDeviceLocale(state),
  isHomePageABCTestEnabled: getIsHomePageABCTestEnabled(state),
  homePageABCTestChances: getHomePageABCTestChances(state),
  homePageABCTestHash: getHomePageABCTestHash(state),
});

export const useLoadHomePageTestConfig = () => {
  const dispatch = useDispatch();
  const breakpoint = useBreakpointPrecise();

  const {
    isHomePageABCTestEnabled,
    homePageABCTestChances,
    homePageABCTestHash,
    locale,
  } = useSelector(selector);

  const isHomePageABCTestForDomainEnabled =
    getHomePageABCTestForDomainEnabled();

  const numberHomePageABCTestChances = homePageABCTestChances.map(Number);

  const device =
    breakpoint === Breakpoints.DESKTOP
      ? Breakpoints.DESKTOP
      : Breakpoints.MOBILE;

  useMount(() => {
    if (isHomePageABCTestEnabled && isHomePageABCTestForDomainEnabled) {
      const testVariant = generateHomePageABCTestVariant(
        locale,
        numberHomePageABCTestChances
      );

      const testObject = getHomePageABCTestObject(
        testVariant,
        homePageABCTestHash,
        device
      );

      if (testObject) {
        dispatch(setBgVideo({ bgVideo: testObject.videoUrl }));
        dispatch(
          setABCTestValues({
            header: testObject.header,
            subHeader: testObject.subHeader,
            screenName: testObject.screenName,
          })
        );
      }
    }
  });
};
